import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers, { RootState } from './reducers';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__: any;
  }
}

export default function configureStore(ssrState: RootState | {} = {}) {
  const persistConfig = {
    key: 'cashewPayments',
    storage,
    whitelist: ['user'], // which reducer want to store
  };
  const middlewares = [thunkMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];
  if (typeof window !== 'undefined') {
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
      enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }
  }
  const pReducer = persistReducer(persistConfig, reducers);

  const store: any = createStore(pReducer, ssrState, compose(...enhancers));
  const persistor = persistStore(store);

  store.asyncReducers = {}; // Async reducer registry

  return { store, persistor };
}
